// 曼易电子特殊处理
import { buildOnline } from "@/utils/global"
import _ from "lodash"

export const ManYiDianZi = {
    CompanyId: 133,
}

export function isManYiDianZiWork(store) {
    if (!buildOnline) {
        return false
    }
    return _.get(store, 'getters.currentParentCompany') === ManYiDianZi.CompanyId
}
